import { KalturaESearchCategoryResult } from "kaltura-typescript-client/api/types/KalturaESearchCategoryResult";
import { Icon, StyledChannelItem, StyledTypography, StyledLi } from "./StyledComponents";
import { Tooltip } from "@kaltura/ds-react-components";
import { Truncate } from "@kaltura/mediaspace-shared-ui";
import { addBaseUrl } from "@kaltura/mediaspace-shared-utils";
import { SearchCategory } from "./../../../types";

export interface ChannelItemProps {
    searchResult: KalturaESearchCategoryResult;
}

const baseClassName = "kms-ds-global-search-channel-results-channels-list-item";

/**
 * single channel search result
 */
export function ChannelItem({ searchResult }: ChannelItemProps) {
    const category = searchResult.object as unknown as SearchCategory;
    const { name, url, thumbnailUrl } = category;
    return (
        <StyledLi>
            <StyledChannelItem href={addBaseUrl(url)} target={"_blank"} className={`${baseClassName}`}>
                <Icon style={{ backgroundImage: `url(${thumbnailUrl})` }} className={`${baseClassName}-icon`} />
                <Tooltip title={name} placement={"top"} describeChild={true}>
                    <StyledTypography variant={"body1"} component="div" className={`${baseClassName}-name`}>
                        <Truncate lines={2} showMore={false}>
                            {name}
                        </Truncate>
                    </StyledTypography>
                </Tooltip>
            </StyledChannelItem>
        </StyledLi>
    );
}

export default ChannelItem;
